export default {
  tableDataWalletAdjustment: state => {
    return state.walletAdjustmentList
  },
  tableDataWalletGiroPayment: state => {
    return state.walletGiroPaymentList
  },
  tableDataWalletGiroRejectedPayment: state => {
    return state.walletGiroRejectedPaymentList
  },
  getMemberWalletData: state => {
    return state.wallet.data
  },
}
